import { Link } from 'react-router-dom';
import React from 'react';
import { Helmet } from 'react-helmet';
// import { Link } from 'react-router-dom';
import './ReconditionnementOrdinateur.css';

const ReconditionnementOrdinateur = () => {
  return (
    <>
      <Helmet>
        <title>Reconditionnement d'ordinateur - Mon Dépannage Informatique</title>
        <meta name="description" content="Upgrade Informatique : spécialiste du reconditionnement d'ordinateurs fixes et portables à Rezé, aux portes de Nantes. Tarifs compétitifs, démarche éco-responsable." />
        <meta name="keywords" content="reconditionnement ordinateur, upgrade informatique, Rezé, Nantes, modernisation PC, SPEED UP, SSD, performances" />
      </Helmet>
      
      <div className="page-content">
        <div className="container">
          <article className="page-article">
            <div className="entry-content">
              <h1>Votre expert informatique de confiance au service des particuliers et professionnels sur Nantes et sa région</h1>
              
              <h2>Upgrade Informatique : votre spécialiste du reconditionnement d'ordinateurs fixes et portables à Rezé, aux portes de Nantes !</h2>
              
              <p>
                Notre expertise vous garantit un reconditionnement professionnel de votre PC à des tarifs particulièrement compétitifs.
              </p>

              <p>
                Notre démarche éco-responsable s'inscrit dans une logique anti-gaspillage, incarnant parfaitement le principe vertueux :
              </p>

              <p className="highlight-quote">
                <strong>« Transformer l'ancien en moderne »</strong>
              </p>

              <h3 className="green-title">
                <span>Qu'implique exactement le processus de reconditionnement ?</span>
              </h3>
              
              <p>
                Le reconditionnement représente un équilibre optimal entre performances techniques et maîtrise budgétaire.
              </p>

              <p>
                Vous possédez un ordinateur vieillissant qui vous semble dépassé, mais vos moyens financiers ne vous permettent pas d'investir dans un équipement neuf ?
              </p>

              <p>
                Notre service de reconditionnement est la réponse adaptée à vos besoins !
              </p>

              <p>
                Après une analyse approfondie des caractéristiques techniques de votre machine, nous élaborons ensemble un plan de mise à niveau personnalisé des composants pour garantir une utilisation fluide et performante sous Windows 10, offrant ainsi une seconde jeunesse à votre équipement.
              </p>

              <p>
                En définitive, le reconditionnement consiste à <strong>moderniser</strong> votre ordinateur pour répondre aux exigences actuelles !
              </p>

              <div className="image-caption">
                <img 
                  src="http://web.archive.org/web/20220701075503im_/https://mon-depannage-informatique.fr/wp-content/uploads/2022/03/paralax-icline-reconditionnement-dordinateur.png" 
                  alt="Reconditionnement d'ordinateur professionnel"
                  className="content-image"
                />
              </div>

              <h3>Une expertise informatique professionnelle et dynamique à votre disposition à Rezé, proximité Nantes</h3>
              
              <p>
                Explorez notre solution d'excellence en matière de reconditionnement informatique !
              </p>

              <p>
                Découvrez le <strong>SPEED UP</strong>
              </p>

              <p>
                Cette intervention technique sophistiquée optimise radicalement les performances globales de votre ordinateur tout en préservant l'intégralité de votre environnement numérique habituel.
              </p>

              <p>
                Notre protocole d'<strong><u>optimisation</u></strong> avancé libère le potentiel inexploité de votre machine, augmente significativement sa longévité tout en conservant votre configuration système identique (une solution particulièrement prisée par les entreprises utilisant des logiciels métiers spécifiques).
              </p>

              <p>
                Un démarrage qui nécessitait plusieurs minutes s'effectuera désormais en quelques secondes seulement.
              </p>

              <p>
                Notre formule <strong>SPEED UP</strong> garantit une amélioration spectaculaire des performances, la seule différence perceptible sera l'extraordinaire gain de vitesse !
              </p>

              <p>
                Découvrez nos tarifs <strong>SPEED UP</strong> :
              </p>

              <div className="pricing-table">
                <div className="pricing-row">
                  <div className="pricing-cell">
                    <div>240 Go de capacité de stockage SSD</div>
                    <span></span>
                  </div>
                  <div className="pricing-cell price">199 €</div>
                </div>
                
                <div className="pricing-row">
                  <div className="pricing-cell">
                    <div>Extension à 500 Go</div>
                    <span></span>
                  </div>
                  <div className="pricing-cell price">Supplément de 40€</div>
                </div>
              </div>

              <p>
                Partagez-nous vos besoins en matière de dépannage informatique, migration système et récupération de données.
              </p>

              <p>
                Sollicitez votre devis personnalisé dès maintenant !
              </p>

              <div className="contact-cta">
                <h2>Besoin d'un reconditionnement d'ordinateur ?</h2>
                <p>Transformez votre ancien PC en machine moderne !</p>
                <p>Contactez Maxence Huret au <Link to="/contact" className="phone-link">Contactez-nous</Link></p>
                <a href="tel:0662961213" className="btn btn-primary">Obtenir un devis gratuit</a>
              </div>
            </div>
          </article>
        </div>
      </div>
    </>
  );
};

export default ReconditionnementOrdinateur;
